import React, { createContext, useState } from "react";

interface Path {
  name: string;
  link?: string;
}

export const Context = createContext<{
  paths: Path[];
  setBreadcrumb: (p: Path[]) => void;
}>({ paths: [], setBreadcrumb: () => null });

export const BreadCrumbProvider: React.FC = ({ children }) => {
  const [paths, setPaths] = useState<Path[]>([]);

  const setBreadcrumb = (p: Path[]) => {
    setPaths(p);
  };

  return (
    <Context.Provider value={{ paths, setBreadcrumb }}>
      {children}
    </Context.Provider>
  );
};
